import {emptySplitApi} from "./empty.api";
import {CryptoCurrency} from "../models/Wallet";

export const cryptocurrencyRewardsApi = emptySplitApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({

    sendPublicAddress: build.mutation<any, {wallet_public_address: string}>({
      query: (body) => ({
        url: "/cryptocurrency-rewards/send-public-address",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ['User']
    }),

  }),
});

export const {
  useSendPublicAddressMutation
} = cryptocurrencyRewardsApi;